export default "__VITE_ASSET__13cc534d__"